import SendBulkEmailPage from './send_bulk_email';

export default SendBulkEmailPage